function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.03533 2.08135C7.34867 2.02868 7.67067 1.99935 8 1.99935C11.314 1.99935 14 4.68535 14 7.99935C14 9.16068 13.6667 10.2413 13.094 11.158C13.2447 10.5733 13.3333 9.96402 13.3333 9.33268C13.3333 5.64135 10.5893 2.58668 7.03533 2.08135ZM15.3333 7.99935C15.3333 8.63068 15.2447 9.24002 15.094 9.82468C15.6667 8.90801 16 7.82735 16 6.66602C16 3.35202 13.314 0.666016 10 0.666016C9.67067 0.666016 9.34867 0.695349 9.03533 0.748016C12.5893 1.25335 15.3333 4.30802 15.3333 7.99935ZM12 9.33268C12 12.6467 9.314 15.3327 6 15.3327C2.686 15.3327 0 12.6467 0 9.33268C0 6.01868 2.686 3.33268 6 3.33268C9.314 3.33268 12 6.01868 12 9.33268Z",
  fill: "#6B7280"
});

function SvgToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken);
export default __webpack_public_path__ + "static/media/token.976c756875542e4984b7b545ef32aadd.svg";
export { ForwardRef as ReactComponent };